import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRobot,
  faChartPie,
  faEnvelopeOpenText,
  faMobileScreen,
  faCode,
  faUserShield,
  faComments,
  faPaintBrush
} from '@fortawesome/free-solid-svg-icons';

const TopFeaturesSection = styled.section`
  padding: 40px 0 40px 0;
  background: var(--light-color);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at top right, rgba(255, 77, 0, 0.1), transparent 60%);
    z-index: 1;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 36px;
    color: var(--dark-color);
    margin-bottom: 20px;
    font-weight: 700;
  }

  p {
    font-size: 18px;
    color: #666;
    max-width: 600px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 28px;
    }
    p {
      font-size: 16px;
    }
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
`;

const FeatureCard = styled.div`
  background: var(--white);
  border-radius: var(--border-radius);
  padding: 30px;
  box-shadow: var(--box-shadow);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 77, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(255, 77, 0, 0.1);
  }
`;

const FeatureIcon = styled.div`
  width: 60px;
  height: 60px;
  background: var(--gradient);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 24px;
  color: var(--white);
  transform: rotate(-5deg);
  transition: transform 0.3s ease;

  ${FeatureCard}:hover & {
    transform: rotate(0deg);
  }
`;

const FeatureTitle = styled.h3`
  font-size: 20px;
  color: var(--dark-color);
  margin-bottom: 15px;
  font-weight: 600;
`;

const FeatureDescription = styled.p`
  color: #666;
  line-height: 1.6;
  flex-grow: 1;
`;

const features = [
  {
    icon: faComments,
    title: 'WhatsApp Support',
    description: 'Engage with customers directly on WhatsApp using a centralized, streamlined platform built for real-time communication.'
  },
  {
    icon: faRobot,
    title: 'AI-Powered Automation',
    description: 'Leverage advanced AI to automate your marketing tasks and workflows with precision.'
  },
  {
    icon: faUserShield,
    title: 'Advanced Security',
    description: 'Keep your data safe with enterprise-grade security features and compliance measures.'
  },
  {
    icon: faPaintBrush,
    title: 'Beautiful Templates',
    description: 'Choose from hundreds of professionally designed templates for all your marketing needs.'
  },
  {
    icon: faMobileScreen,
    title: 'Mobile Optimization',
    description: 'Reach customers on any device with fully responsive and mobile-optimized campaigns.'
  },
  // {
  //   icon: faChartPie,
  //   title: 'Advanced Analytics',
  //   description: 'Get deep insights into your marketing performance with detailed analytics and reporting.'
  // },
  // {
  //   icon: faEnvelopeOpenText,
  //   title: 'Smart Email Marketing',
  //   description: 'Create and send personalized email campaigns that convert with our intelligent system.'
  // },
  // {
  //   icon: faCode,
  //   title: 'Custom Integration',
  //   description: 'Connect with your favorite tools and services using our powerful API and webhooks.'
  // },

];

const TopFeatures: React.FC = () => {
  return (
    <TopFeaturesSection id="features">
      <Container>
        <SectionTitle data-aos="fade-up">
          <h2>✨ Top Features You'll Love</h2>
          <p>Discover the powerful features that will help you grow your business faster.</p>
        </SectionTitle>
        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <FeatureIcon>
                <FontAwesomeIcon icon={feature.icon} />
              </FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeaturesGrid>
      </Container>
    </TopFeaturesSection>
  );
};

export default TopFeatures; 